import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const styles = {
  button: {
    width: '100%',
    fontWeight: 'bold',
    backgroundColor: '#ff5722',
    borderColor: '#ff5722'
  },
  buttonFukuoka: {
    width: '100%',
    fontWeight: 'bold',
    backgroundColor: '#f50057',
    borderColor: '#f50057'
  }
};

const enhance = compose(pure);

const button = enhance(({ classes, onClickAction, disabled, isFukuoka }) => {
  return (
    <Button
      variant="contained"
      color="secondary"
      disableElevation
      className={isFukuoka ? classes.buttonFukuoka : classes.button}
      onClick={onClickAction}
      disabled={disabled}
    >
      {isFukuoka ? '精算確定' : '請求確定'}
    </Button>
  );
});

export default withStyles(styles)(button);
